import type { InputFieldClearButtonData, InputProps } from '@presentation/components';

export interface InputFieldProps extends InputProps {
  name: string;
  clearButton?: InputFieldClearButtonData<string | number>;
}
